import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  HStack,
  Text,
  Image,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiCheck } from "react-icons/fi";
import { motion } from "framer-motion";

const MotionBox = motion.div;

const languages = [
  { code: "es", label: "Spanish", flag: "https://flagcdn.com/es.svg" },
  { code: "en", label: "English", flag: "https://flagcdn.com/us.svg" },
  { code: "pt", label: "Portuguese", flag: "https://flagcdn.com/pt.svg" },
  { code: "zh", label: "Chinese (Simplified)", flag: "https://flagcdn.com/cn.svg" },
  { code: "zh-TW", label: "Chinese (Traditional)", flag: "https://flagcdn.com/tw.svg" },
];

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLang =
    languages.find((lang) => lang.code === i18n.language) || languages[0];
  const [selectedLanguage, setSelectedLanguage] = useState(currentLang);

  const bgHover = useColorModeValue("gray.100", "gray.700");
  const menuBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const selectedColor = useColorModeValue("blue.500", "blue.300");

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.body.dir = i18n.dir();
  }, [i18n]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        variant="ghost"
        px={3}
        py={2}
        rounded="md"
        _hover={{ bg: bgHover }}
      >
        <HStack spacing={2}>
          <Image
            src={selectedLanguage.flag}
            boxSize="18px"
            alt={selectedLanguage.label}
          />
          <Text fontSize="xs">{selectedLanguage.label}</Text>
        </HStack>
      </MenuButton>

      <MenuList
        bg={menuBg}
        borderColor={borderColor}
        shadow="md"
        rounded="none"
        py={1}
      >
        <MotionBox
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
        >
          {languages.map((lang) => {
            const isSelected = lang.code === selectedLanguage.code;

            return (
              <MenuItem
                key={lang.code}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setSelectedLanguage(lang);
                }}
                _hover={{ bg: bgHover }}
              >
                <HStack spacing={3} justify="space-between" width="100%">
                  <HStack spacing={3}>
                    <Image
                      src={lang.flag}
                      boxSize="20px"
                      alt={lang.label}
                      borderRadius="full"
                    />
                    <Text
                      fontSize="sm"
                      fontWeight={isSelected ? "bold" : "normal"}
                      color={isSelected ? selectedColor : "inherit"}
                    >
                      {lang.label}
                    </Text>
                  </HStack>
                  {isSelected && (
                    <Icon as={FiCheck} color={selectedColor} boxSize={4} />
                  )}
                </HStack>
              </MenuItem>
            );
          })}
        </MotionBox>
      </MenuList>
    </Menu>
  );
};
